/**
 * Приёмник живых данных: коллектор на liquorice-mm-2 хвостиком читает WAL
 * бота (var/live/mm-*.jsonl) и раз в 2 с выгружает срез в GCS. Отсюда его
 * забираем поллингом — тот же ритм, что раньше был у мока, просто источник
 * настоящий. Код коллектора: dashboard/live/collector.py.
 *
 * GCS не умеет bigint — Units-поля приходят десятичными строками, здесь
 * единственное место, где они оживают обратно в bigint. derived считаем тут
 * же через derivePool(), а не в Python: «единственное место, где считаются
 * деньги пула» — это pool-math.ts, и это не должно раздваиваться.
 *
 * Чего пока в живом снимке НЕТ: ценовой график (ourBid/ourAsk/Uniswap ряды)
 * остаётся синтетикой из data/market.ts — у бота нет истории котировок,
 * только текущий срез. trades/pnl почти всегда пустые не потому что баг:
 * settlement_observed/fill_accounted живой канарейкой не пишутся вовсе,
 * см. liquorice_mm/lending_canary_runner.py.
 */
import type { Asset, PoolSnapshot, Snapshot } from '../types'
import { derivePool } from '../lib/pool-math'

const BIGINT_ASSET_FIELDS = [
  'lockedCollateralUnits',
  'debtUnits',
  'walletBalanceUnits',
  'poolLiquidityUnits',
  'totalLockedDepositsUnits',
  'availableBorrowUnits',
  'oraclePriceUnits',
  'maxLtvUnits',
] as const

function reviveAsset(raw: Record<string, unknown>) {
  const out: Record<string, unknown> = { ...raw }
  for (const f of BIGINT_ASSET_FIELDS) {
    const v = raw[f]
    out[f] = v == null ? null : BigInt(v as string)
  }
  return out
}

export function reviveSnapshot(raw: any): Snapshot {
  const rawPool = raw.pool
  const pool: PoolSnapshot = {
    ...rawPool,
    liquidationThresholdUnits: BigInt(rawPool.liquidationThresholdUnits),
    userLtvUnits: BigInt(rawPool.userLtvUnits),
    assets: Object.fromEntries(
      (Object.entries(rawPool.assets) as [Asset, Record<string, unknown>][]).map(
        ([sym, a]) => [sym, reviveAsset(a)],
      ),
    ) as unknown as PoolSnapshot['assets'],
  }
  return { ...raw, pool, derived: derivePool(pool) } as Snapshot
}
